import { Comparable } from "@siteimprove/alfa-comparable";
/**
 * @public
 */
export var Order;
(function (Order) {
    Order.compare = Comparable.compareNumber;
})(Order || (Order = {}));
//# sourceMappingURL=order.js.map